






































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action } from 'vuex-class';
import { sha256 } from 'js-sha256';

const AUTH_WRONG_PASSWORD = 'Wrong password';

const namespace = 'profile';

@Component
export default class Login extends Vue {
  login = '';

  password = '';

  isAuthSent = false;

  isGoogleAuthSent = false;

  authError = '';

  showPassword = false;

  @Action('fetchUserData', { namespace }) fetchUserData: any;

  @Action('authGoogle', { namespace }) authGoogleAction: any;

  @Action('auth', { namespace }) authAction: any;

  get session() {
    return this.$store.getters['profile/getSession'];
  }

  get isButtonsDisabled(): boolean {
    return this.isAuthSent || this.isGoogleAuthSent;
  }

  get isWrongPassword(): boolean {
    return this.authError === AUTH_WRONG_PASSWORD;
  }

  /* methods */
  async gauth() {
    this.isGoogleAuthSent = true;
    try {
      // @ts-expect-error: no vue support in library
      const authData = await this.$gAuth.signIn();
      authData.userData = authData.getBasicProfile();
      await this.authGoogleAction(authData);
      this.isGoogleAuthSent = false;
      this.authError = '';
      if (this.session) {
        this.$router.push({ name: 'Profile' });
      }
    } catch (e) {
      this.authError = e.message;
      this.isGoogleAuthSent = false;
    }
  }

  async auth() {
    this.isAuthSent = true;
    try {
      const password = sha256.update(this.password);
      await this.authAction({
        login: this.login,
        password: password.toString(),
      });
      this.isAuthSent = false;
      this.authError = '';
      if (this.session) {
        this.$router.push({ name: 'Profile' });
      }
    } catch (e) {
      this.authError = e.message;
      this.isAuthSent = false;
    }
  }
}
